import React from 'react'
import { useThemeTokens } from '../../themes'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost'
  size?: 'sm' | 'md' | 'lg'
  children: React.ReactNode
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  ...props
}) => {
  const theme = useThemeTokens()
  
  const baseStyles: React.CSSProperties = {
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeight.medium,
    border: `1px solid`,
    borderRadius: theme.borderRadius[size === 'sm' ? 'sm' : 'md'],
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    opacity: props.disabled ? 0.5 : 1,
  }
  
  const variantStyles: Record<string, React.CSSProperties> = {
    primary: {
      backgroundColor: theme.colors.primary,
      color: '#ffffff',
      borderColor: theme.colors.primary,
    },
    secondary: {
      backgroundColor: theme.colors.surface,
      color: theme.colors.text,
      borderColor: theme.colors.border,
    },
    danger: {
      backgroundColor: theme.colors.error,
      color: '#ffffff',
      borderColor: theme.colors.error,
    },
    ghost: {
      backgroundColor: 'transparent',
      color: theme.colors.text,
      borderColor: 'transparent',
    }
  }
  
  const sizeStyles: Record<string, React.CSSProperties> = {
    sm: {
      padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
      fontSize: theme.typography.fontSize.sm,
    },
    md: {
      padding: `${theme.spacing.sm} ${theme.spacing.md}`,
      fontSize: theme.typography.fontSize.sm,
    },
    lg: {
      padding: `${theme.spacing.md} ${theme.spacing.lg}`,
      fontSize: theme.typography.fontSize.md,
    }
  }
  
  const combinedStyles: React.CSSProperties = {
    ...baseStyles,
    ...variantStyles[variant],
    ...sizeStyles[size],
  }
  
  return (
    <button style={combinedStyles} className={className} {...props}>
      {children}
    </button>
  )
} 